const DEFAULT_LABEL_HEIGHT = 144;
const DEFAULT_LABEL_EMAIL_HEIGHT = 192;
const EXPANDED_LABEL_HEIGHT = 208;
const EXPANDED_LABEL_EMAIL_HEIGHT = 408;
const MOBILE_LABEL_HEIGHT = 90;
const SPACER_BASE_SIZE = 60;
const SPACER_EXPANDED_SIZE = 100;
const SPACER_EXPANDED_WITH_INFO_SIZE = 160;
const CHANNEL_IMAGE_DIMENSIONS = {
    width: 24,
    height: 24,
};

export {
    DEFAULT_LABEL_HEIGHT,
    DEFAULT_LABEL_EMAIL_HEIGHT,
    EXPANDED_LABEL_HEIGHT,
    EXPANDED_LABEL_EMAIL_HEIGHT,
    MOBILE_LABEL_HEIGHT,
    SPACER_BASE_SIZE,
    SPACER_EXPANDED_SIZE,
    SPACER_EXPANDED_WITH_INFO_SIZE,
    CHANNEL_IMAGE_DIMENSIONS,
};

export type Info = {
    text: string;
    variant: 'info' | 'warning';
    disableInput?: boolean;
};
